// extracted by mini-css-extract-plugin
module.exports = {"bannerWrapper":"warningModal_bannerWrapper__1K_Qq","modal-title":"warningModal_modal-title__1jCut","modal-text":"warningModal_modal-text__1-RuD"};